import dispatch from 'utils/dispatcher';
import {MESSAGES} from '../store/constants';

import api from '../lib/api';

/* Stores */

import StoreStore from '../store';

/* VARS */

let messagePolling;

/**
 * @deprecated
 */
const StoreActions = {
	/* Messages */

	pollForMessages() {
		clearInterval(messagePolling);
		this.fetchMessages();
		messagePolling = setInterval(() => {
			this.fetchMessages();
		}, 60_000);
	},

	stopPollForMessages() {
		clearInterval(messagePolling);
	},

	appendMessage(message) {
		dispatch(MESSAGES.APPEND_MESSAGE, message);
	},

	async fetchMessages() {
		try {
			const messages = await api('get', '/api/messages');
			dispatch(MESSAGES.LOAD, messages);
		} catch {
			// continue
		}
	},

	readMessage(id) {
		api('patch', '/api/messages/' + id, null, {read: 1}).then(() => {
			StoreStore.setMessageRead(id);
		});
	},

	readAllMessages() {
		api('patch', '/api/messages/', null, {read: 1}).then(() => {
			StoreStore.setMessageAllRead();
		});
	},
};

export default StoreActions;
